import React from 'react';
import ReactDOM from 'react-dom/client'; // Using React 18+
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Ensure this matches the `id` in your public/index.html
const rootElement = document.getElementById('root');

if (rootElement) {
  // Using React 18's `createRoot` API
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  console.error("Root element not found");
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
